export default __webpack_public_path__ + "static/media/rocket.08fc88a7.svg";